import PubSub from "underpub-js";
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import { 
	OverlayScrollbars, 
	ScrollbarsHidingPlugin, 
	SizeObserverPlugin, 
	ClickScrollPlugin 
} from 'overlayscrollbars';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

/**
 * Sitewide
 */
var Sitewide = function () {

};

/**
 * Init
 */
Sitewide.prototype.init = function () {

	var self = this;

	this.initEvents();

	// init smooth scrolling
	ScrollSmoother.create({
		smooth: 1.5, // how long (in seconds) it takes to "catch up" to the native scroll position
		// effects: true, // looks for data-speed and data-lag attributes on elements
		// smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
	});

	if (!ScrollTrigger.isTouch) {

		// init overlayScrollBars to hide scroll bar on non-touch devices
		self.htmlScroller = OverlayScrollbars({ target: $(`body`).get(0) }, {
			scrollbars: {
				theme: null
			}
		});

	}

	this.initAnimateIn();

};

/**
 * Init'ing our global events, many of which we publish
 */
Sitewide.prototype.initEvents = function () {
	//
	// Resizing (at the start)
	//
	var windowThrottled = _.throttle(
		function (e) {
			PubSub.publish('Sitewide:resize');
		},
		200, {
			trailing: false
		},
	);
	window.addEventListener('resize', windowThrottled, false);

	//
	// Resized Event (at the end)
	//
	var windowResizeDebounce = _.debounce(function (e) {
		PubSub.publish('Sitewide:resized');
	}, 200);
	window.addEventListener('resize', windowResizeDebounce, false);

	$("a[href^='#']").on("click", (e) => {
		e.preventDefault();
	});

};

Sitewide.prototype.initAnimateIn = function () {

	var self = this;

	let $animateInItems = $(`.animate-in`);

	$animateInItems.each(function() {

		let $item = $(this);

		gsap.to($item, {
			scrollTrigger: {
				trigger: $item,
				start: function() {

					let itemHeight = $item.outerHeight();
					let start = "bottom+=20px bottom";

					if (itemHeight > 250) {
						start = "top+=140px bottom";
					}
					else if (itemHeight > 150) {
						start = "top+=80% bottom";
					}
					else if (itemHeight > 100) {
						start = "bottom bottom";
					}

					return start;

				},
				// markers: true,
			},
			duration: 1.25,
			ease: "power3.out",
			y: 0,
			opacity: 1,
		});

	});

	

};

export default Sitewide;